import type { IndicatorPosition } from '../lib/use-nav-indicator'
import s from './NavIndicator.module.css'

/**
 * Полоса под активным табом (макет: `<div id="pbnavind">`, стиль `navIndStyle`).
 *
 * Компонент нарочно тупой: он только рисует. Замер живёт в `useNavIndicator` и зовётся из
 * `NavBar` — владельца контейнера. Если перенести замер сюда, он сломается, и молча: подробности
 * в комментарии к самому хуку.
 *
 * Полоса шириной 1px, растянутая `scaleX` до ширины таба, — так в макете, и так и надо:
 * анимируется только `transform`, то есть композитингом, без пересчёта раскладки на каждом
 * кадре 460-миллисекундного переезда.
 *
 * Позиция — инлайном, а не классом: это вычисляемая геометрия, единственное, для чего инлайн
 * и разрешён.
 */
export function NavIndicator({ position }: { position: IndicatorPosition | null }) {
  if (!position) return null

  return (
    <div
      className={s.root}
      style={{ transform: `translateX(${position.left}px) scaleX(${position.width})` }}
    />
  )
}
